import Loading from './Modules/Loading'
import Authentication from './Modules/Authentication'
import User from './Modules/User'
import Brand from './Modules/Brand'
import Category from './Modules/Category'
import Address from './Modules/Address'
import City from './Modules/City'
import Province from './Modules/Province'
import Feature from './Modules/Feature'
import Product from './Modules/Product'
import SiteInfo from './Modules/SiteInfo'
import ShoppingCart from './Modules/ShoppingCart'
import Offer from './Modules/Offer'
import Transaction from './Modules/Transaction'
import Content from './Modules/Content'
import Course from './Modules/Course'
import FileManager from './Modules/FileManager'
import Menu from './Modules/Menu'
import Comment from './Modules/Comment'
import Timing from './Modules/Timing'
import Search from './Modules/Search'
import Delivery from './Modules/Delivery'
import Crawler from './Modules/Crawler'
import Bulk from './Modules/Bulk'
import Wallet from './Modules/Wallet'
import Loan from './Modules/Loan'
import Language from './Modules/Language'
import Captcha from './Modules/Captcha'
import MultipleStore from './Modules/MultipleStore'
import Chat from './Modules/Chat'
import Reservation from './Modules/Reservation'
import Statistic from './Modules/Statistic'
import StepManager from './Modules/StepManager'
import WishList from './Modules/WishList'
import Skeleton from './Modules/Skeleton'
import Tag from './Modules/Tag'
import Basalam from './Modules/Basalam'
import Sms from './Modules/Sms'
import NotifyUserProduct from './Modules/NotifyUserProduct'
import SiteServiceManager from './Modules/SiteServiceManager'
import Subscription from './Modules/Subscription'
import Form from './Modules/Form'
import Meta from './Modules/Meta'
import Log from './Modules/Log'

const modulesPaths = {
    Loading,
    Authentication,
    User,
    Brand,
    Category,
    Address,
    City,
    Province,
    Feature,
    Product,
    SiteInfo,
    ShoppingCart,
    Offer,
    Transaction,
    Content,
    Course,
    FileManager,
    Menu,
    Comment,
    Timing,
    Search,
    Delivery,
    Crawler,
    Bulk,
    Wallet,
    Loan,
    Language,
    Captcha,
    MultipleStore,
    Chat,
    Reservation,
    Statistic,
    StepManager,
    WishList,
    Skeleton,
    Tag,
    Basalam,
    Sms,
    NotifyUserProduct,
    SiteServiceManager,
    Subscription,
    Form,
    Meta,
    Log,
}

export default modulesPaths